module.exports = __webpack_public_path__ + "static/img/title@2x.20d1673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb_min/title@2x.png
// module id = yBoh
// module chunks = 69